<!-- logoin模态框的封装 -->
<form nz-form [formGroup]="loginModalForm">
  <nz-form-item>
    <nz-form-label nzRequired nzFor="userName">用户名</nz-form-label>
    <nz-form-control nzErrorTip="请输入角色名">
      <input nz-input formControlName="userName" name="userName" placeholder="请输入角色名" id="userName"/>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label nzFor="roleDesc">密码</nz-form-label>
    <nz-form-control>
      <input nz-input formControlName="password" name="password" placeholder="请输入密码" id="password"/>
    </nz-form-control>
  </nz-form-item>
</form>
